import { createLogic } from 'redux-logic';
import { FETCH_CONTEXT } from './types';
import { fetchContextFulfilled, fetchContextRejected } from './actions';
import { validatePxConfigurations } from 'utils';

export const fetchContextLogic = createLogic({
  type: FETCH_CONTEXT,
  latest: true,

  async process({ action }, dispatch, done) {
    try {
      const posContext = await action.payload.getPosContext();
      const pxContext = action.payload.getPxContext();

      const validatedPxConfigurations = validatePxConfigurations(
        posContext.configurations
      );

      const validatedPosContext = {
        ...posContext,
        configurations: validatedPxConfigurations,
      };
      dispatch(fetchContextFulfilled(validatedPosContext, pxContext));
    } catch (error) {
      dispatch(fetchContextRejected(error));
    }
    done();
  },
});
